import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/sluzby-a-reseni" as const,
} satisfies LocalizedString;

export function getServicesSolutionsPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
